export const packageTypes = {
  DEFAULT: 'baraem',
  FREE_TRIAL: 'freeTrial',
};
